import { setWorkerUrl } from 'maplibre-gl';
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?url';

/**
 * MapLibre looks for its worker next to its own module (`import.meta.url`),
 * which a bundled chunk is not — and Vite never emits the worker file unless
 * something imports it. `?url` makes it an asset and hands MapLibre its URL.
 *
 * Imported once from the entry, before any map exists: `SupplyChainMap` in
 * ui-components-lib shares this `maplibre-gl` instance (see `resolve.dedupe`
 * in vite.config.ts), so this one call covers its maps too.
 */
setWorkerUrl(workerUrl);
